import React, { useState, useEffect, useMemo } from 'react'
import Maybe from 'components/__new/common/Maybe';
import { Input, SelectInput } from 'components/__new/common/form';
import { ReactComponent as IconSearch } from "assets/images/icons/icon-search.svg";
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
import { useDispatch, useSelector } from 'react-redux';
import * as walletAction from "store/entities/wallet/action";
import { toast } from 'react-toastify';
import { getTransferBeneficiaries } from 'store/entities/transfers/action';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useEmptyData from 'hooks/useEmptyData';
import CurrencyFormat from 'utils/currencyFormat';


const EarnipaySingleTransfer = ({toggleEarnipayTransferType, toggleTransferDestination, initiateTransfer, selectedSourceAccount, 
    setSelectedSourceAccount, setRecipientData }) => {
    const dispatch = useDispatch();
    const {validateEarnipayAccountLoading, validateEarnipayAccountData, businessAccounts, businessAccountsLoading} = useSelector((state) => state.entities.wallet)
    const { transferBeneficiariesLoading, transferBeneficiaries } = useSelector((state) => state.entities.transfers)
    
    const [form, setForm] = useState({
        sourceAccount: null,
        accountNumber: "",
        amount: "",
        narration: "",
    });
    const [beneficiariesShown, setBeneficiariesShown] = useState(false);
    const [validatedBeneficiary, setValidatedBeneficiary] = useState(null);
    const expenseAccounts = businessAccounts?.status === "success" && businessAccounts?.data?.filter(account => account?.walletType.toLowerCase() === 'expense') || [];
    
    const isBalanceInsufficient = useMemo(() => {
        return form?.amount?.split(",")?.join("") > (selectedSourceAccount?.balance / 100)
    }, [form?.amount, selectedSourceAccount]);
    
    const disableSubmit = useMemo(() => {
        return form?.accountNumber?.length !== 10 || !form?.amount || !form?.sourceAccount || isBalanceInsufficient;
    }, [form])

    const selectBeneficiary = (beneficiary) => {
        
        if(form?.accountNumber === beneficiary?.accountNumber) {
            toast.error(`${beneficiary?.accountName} has already been selected`)
        } else {
            setValidatedBeneficiary(beneficiary);
            setForm({
                ...form,
                accountNumber: beneficiary?.accountNumber
            });
            setBeneficiariesShown(false);
        }
    }
    
    const closeEarnipayTransfersModal = () => {
        toggleEarnipayTransferType();
        toggleTransferDestination();
    }
    
    const onSubmit = (e) => {
        e.preventDefault();
        
        if(form.amount < 50) {
            toast.error("You can only transfer a minimum of ₦50")
        } else {
            const payload = {
                accountNumber: form?.accountNumber?.toString(),
                amount: Number(form?.amount?.split(",").join("")),
                narration: form?.narration,
                walletId: form?.sourceAccount
            }
            toggleEarnipayTransferType();
            initiateTransfer(payload);
        }
    }
    useEffect(() => {
        if(form?.accountNumber?.length === 10) {
            dispatch(walletAction.validateEarnipayAccount(form?.accountNumber));
        }
        // eslint-disable-next-line
    }, [form.accountNumber])
    
        
    useEffect(() => {
        if(validateEarnipayAccountData?.success === true) {
            setValidatedBeneficiary(validateEarnipayAccountData?.data)
            setRecipientData({...validateEarnipayAccountData?.data, walletId: form?.sourceAccount});
            setForm({
                ...form,
                ...validateEarnipayAccountData?.data
            })
        }
        // eslint-disable-next-line
    }, [validateEarnipayAccountData])
    
    
    useEffect(() => {
        dispatch(getTransferBeneficiaries({type: "intra"}))
        setValidatedBeneficiary(null);
        setForm({
            accountNumber: "",
            amount: "",
            narration: "",
        })
    //  eslint-disable-next-line
    }, [])
    
    useEffect(() => {
        dispatch(walletAction.getBusinessAccounts());
    }, [dispatch]);
    
    return (
        <div className='w-full'>
            <form onSubmit={onSubmit}>
                <SelectInput
                    disabled={businessAccountsLoading}
                    label="Source Account"
                    value={form?.sourceAccount || ""}
                    onChange={(e) => {
                        const { value } = e.target;
                        const selectedSource = expenseAccounts?.find(account => account?.walletId === +value);
                        selectedSource && setSelectedSourceAccount(selectedSource);
                        setForm({...form, sourceAccount: value});
                    }}
                >
                    <option value="">{businessAccountsLoading ? "Fetching source accounts..." : "Select Source Account"}</option>
                    {expenseAccounts?.map((account) => (
                        <option key={account?._id} value={account?.walletId}>{account?.accountName} {account?.isPrimaryAccount && "- Primary"}</option>
                    ))}
                </SelectInput>
                <div className="form-group relative">
                    <div className="w-full flex items-center justify-between">
                        <label>Earnipay Account</label>
                        <div onClick={() => setBeneficiariesShown(!beneficiariesShown)} className='text-sm cursor-pointer border-b border-ep-primary-600 text-ep-primary-600 pb-[0.5px]'>
                            {beneficiariesShown ? "Close search" : "Or Search Beneficiary List"}
                        </div>
                    </div>
                    
                    <input
                        type="text"
                        min={0}
                        id="prl-input"
                        className="form-input"
                        value={form.accountNumber}
                        placeholder="Account Number"
                        disabled={validateEarnipayAccountLoading}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value) && value.length <= 10) {
                                setForm({...form, accountNumber: e.target.value});
                                setValidatedBeneficiary(null);
                            }
                        }}
                    />
                    
                    <Maybe condition={validatedBeneficiary !== null}>
                        <div className="w-full flex items-center justify-start">
                            <div className="flex items-center text-sm">
                                <IconCheckCircle width={15} />
                                <div className='ml-1.5 text-[#153344] capitalize'>
                                    {validatedBeneficiary?.accountName}
                                </div>
                            </div>
                        </div>
                    </Maybe>
                </div>
                        
                <div className="w-full space-y-3">
                    
                    <div className="form-group relative">
                        <label>Amount (Naira)</label>
                        <input
                            type="text"
                            id="prl-input"
                            className="form-input !pl-7"
                            value={form.amount}
                            placeholder="0.00"
                            onChange={(e) => {
                                const { value } = e.target;
                                if (value === "0") return;
                                const cleanedValue = value.replace(/[^\d.]/g, '');
                                const [integerPart, decimalPart] = cleanedValue.split('.');
                                const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                let formattedValue = formattedInteger;
                                if (decimalPart !== undefined) {
                                    formattedValue += '.' + decimalPart.slice(0, 2);
                                }
                                setForm({
                                    ...form, 
                                    amount: formattedValue,
                                })
                            }}
                        />
                        
                        <div className="absolute left-3 top-7">₦&nbsp;</div>
                        <div className="flex justify-between items-center relative">
                            {
                                selectedSourceAccount && (
                                    <div className='flex text-sm text-ep-primary-600 absolute left-0 top-0'>
                                        <p>Balance:</p>&nbsp;
                                        <p>
                                            {CurrencyFormat(selectedSourceAccount?.balance / 100)}
                                        </p>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    {
                        isBalanceInsufficient && (
                            <div className="text-sm text-ep-danger-200">
                                You don't have sufficient balance to complete this transfer
                            </div>
                        )
                    }
                    
                    <div>
                        <div className={`${isBalanceInsufficient ? "mt-4" : selectedSourceAccount ? "mt-8" : ""}`}>
                            <Input
                                type="text"
                                label="Narration"
                                value={form?.narration}
                                className="form-input"
                                placeholder="Narration"
                                onChange={(e) => setForm({...form, narration: e.target.value})}
                            />
                        </div>
                    </div>
                </div>
                
                <div className="border-t w-full flex items-center justify-end mt-7 pt-5">
                    <button type="button" onClick={closeEarnipayTransfersModal} className="btn btn-transparent-primary mr-3">
                        Cancel
                    </button>
                    
                    <button disabled={disableSubmit || validateEarnipayAccountLoading} type="submit" className="btn btn-ep-primary">
                        {validateEarnipayAccountLoading ? "Validating" : "Transfer"}
                    </button>
                </div>
            </form>
        
            <Maybe condition={beneficiariesShown}>
                <BeneficiariesList 
                    selectBeneficiary={selectBeneficiary}
                    loading={transferBeneficiariesLoading}
                    beneficiaries={transferBeneficiaries?.data?.docs}
                />
            </Maybe>
        </div>
    )
}

const BeneficiariesList = ({selectBeneficiary, loading, beneficiaries}) => {
    const [keyword, setKeyword] = useState("");
    const { SearchBeneficiariesEmptyData, ListBeneficiariesEmptyData } = useEmptyData();

    const filteredIntraBeneficiaries = beneficiaries?.filter(beneficiary => beneficiary?.type === "intra");
    
    const filteredBeneficiaries = filteredIntraBeneficiaries?.filter((beneficiary) => {
    if(keyword === "") {
            return true
        } else {
            return beneficiary?.accountName?.toLowerCase()?.includes(keyword?.toLowerCase()) ||
                beneficiary?.accountNumber?.includes(keyword?.toLowerCase())
        }
    })
    
    return (
        <div style={{ position: "absolute", right: "-340px", height: "300px", top: "-25px" }} className="overflow-y-scroll text-sm modal-list-wrap bg-white w-[300px] rounded-lg">

            <Maybe condition={loading === true}>
                <div className="py-5 text-center mt-8">
                    <div className="font-medium">
                        Fetching beneficiaries
                    </div>
                    <div className="mt-4 flex justify-center">
                        <FontAwesomeIcon icon="circle-notch" spin className="text-2xl" />
                    </div>
                </div>
            </Maybe>
            
            <ListBeneficiariesEmptyData condition={loading === false && beneficiaries?.length === 0} />
            
            <Maybe condition={loading === false && beneficiaries?.length > 0}>
                <div className="w-full bg-white sticky top-0 left-0 p-4">
                    <div className="w-full relative">
                        <input
                            type="text"
                            value={keyword}
                            placeholder='Search Beneficiaries' 
                            onChange={(e) => setKeyword(e.target.value)}
                            className='bg-[#f3f4f6] w-full relative text-xs pl-9 !border-0 !ring-0 rounded-lg form-input'
                        />
                        
                        <IconSearch className='absolute left-2 top-2.5' width={18} />
                    </div>
                </div>
                
                <SearchBeneficiariesEmptyData condition={keyword?.length > 0 && filteredBeneficiaries?.length === 0} />
                
                <div className="w-full p-4 pt-1">
                    <div>
                        {filteredBeneficiaries?.map((beneficiary, index) => ( 
                            <div onClick={() => selectBeneficiary(beneficiary)} key={index} className="mb-2.5 pb-2 border-b cursor-pointer">
                                <div className="font-medium text-[#374151] capitalize">
                                    {beneficiary?.accountName?.toLowerCase()}
                                </div>
                                
                                <div className="flex items-center pt-1 text-gray-500">
                                    <div>{beneficiary?.accountNumber}</div>
                                    <span className='h-1 w-1 rounded-full bg-gray-500 mx-1' />
                                    <div>Earnipay</div>
                                </div>
                            </div>
                            )
                        )}
                    </div>
                </div>
            </Maybe>
            
            <div className='sticky bottom-0 h-2 bg-white w-full left-0' />
        </div>
    )
}

export default EarnipaySingleTransfer